function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
import uniqBy from 'lodash/uniqBy';
import { updateObjectInArray } from '../../helpers/arrayHelper';
import { USER_INFO_FETCHED, USER_CONFIG_FETCHED, RECEIVE_USER_PERMISSIONS, RECEIVE_ACCOUNT, SET_ACCOUNT, SET_GOOGLE_QRCODE, CLEAR_GOOGLE_QRCODE } from '../actions/userActions';
import { RECEIVE_VERIFICATION_LEVEL_CONFIGS } from '../actions/withdrawActions';
import { USER_CONFIG_UPDATED, UPDATE_ACCOUNT } from '../actions/kycActions';
import { RECEIVE_KYC } from '../actions/kycIdentityMindActions';
var initialState = {
  userInfo: {},
  permissions: [],
  accounts: [],
  userConfig: [],
  selectedAccountId: undefined,
  kyc: {
    urlParams: null
  },
  qrCode: '',
  verificationLevelConfigs: {}
};
export default function user() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case USER_INFO_FETCHED:
      return Object.assign({}, state, {
        userInfo: payload
      });
    case USER_CONFIG_FETCHED:
      return Object.assign({}, state, {
        userConfig: payload
      });
    case USER_CONFIG_UPDATED:
      return Object.assign({}, state, {
        userConfig: updateObjectInArray(state.userConfig, payload)
      });
    case RECEIVE_USER_PERMISSIONS:
      return Object.assign({}, state, {
        permissions: payload
      });
    case RECEIVE_ACCOUNT:
      return Object.assign({}, state, {
        accounts: uniqBy([].concat(_toConsumableArray(state.accounts), _toConsumableArray(payload)), 'AccountId')
      });
    case UPDATE_ACCOUNT:
      return Object.assign({}, state, {
        accounts: updateObjectInArray(state.accounts, payload)
      });
    case RECEIVE_KYC:
      return Object.assign({}, state, {
        kyc: payload
      });
    case SET_ACCOUNT:
      return Object.assign({}, state, {
        selectedAccountId: payload
      });
    case SET_GOOGLE_QRCODE:
      return Object.assign({}, state, {
        qrCode: payload
      });
    case CLEAR_GOOGLE_QRCODE:
      return Object.assign({}, state, {
        qrCode: ''
      });
    case RECEIVE_VERIFICATION_LEVEL_CONFIGS:
      return Object.assign({}, state, {
        verificationLevelConfigs: payload
      });
    default:
      {
        return state;
      }
  }
}